// =========================================================
// * Vue Material Dashboard Laravel PRO - v1.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-laravel-pro
// * Copyright Creative Tim (https://www.creative-tim.com) & UPDIVISION (https://www.updivision.com)
//
// * Coded by www.creative-tim.com & www.updivision.com
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue';
import posthog from 'posthog-js';

// Fallback token inline: phc_ keys are publishable client identifiers (already
// exposed in every built bundle) and the prod S3-baked .env doesn't carry the
// VUE_APP_POSTHOG_* vars -- without this, prod builds would init PostHog with
// undefined and silently drop all analytics + error tracking.
posthog.init(process.env.VUE_APP_POSTHOG_TOKEN || 'phc_vezXgBAoTnvum66KkduwxBYJQ4FzavXwnT5LApGbuirL', {
  api_host: process.env.VUE_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
  defaults: '2026-01-30',
  capture_pageview: false,
});

export { posthog };

//import VueCompositionAPI from '@vue/composition-api'
//Vue.use(VueCompositionAPI);

import axios from 'axios';

// Plugins
// Critical first:
import errorHandler from './store/modules/error-handler-module';

import App from './App.vue';
import Chartist from 'chartist';
import VueAxios from 'vue-axios';
import DashboardPlugin from './material-dashboard';
import VueMeta from 'vue-meta';
import IsDemo from './isDemo';
import VueScrollTo from 'vue-scrollto';
import Popover from 'vue-js-popover';
import Vuelidate from 'vuelidate';
import VueMoment from 'vue-moment';
import JsonCSV from 'vue-json-csv';
import vueDebounce from 'vue-debounce';
import vueCountryRegionSelect from 'vue-country-region-select';
import VueClickOutsideComponent from 'vue-click-outside-component';
import { StripePlugin } from '@vue-stripe/vue-stripe';
import browserDetect from 'vue-browser-detect-plugin';

const stripeOptions = {
  pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
  stripeAccount: process.env.VUE_APP_STRIPE_ACCOUNT,
  apiVersion: process.env.VUE_APP_STRIPE_API_VERSION,
  locale: process.env.VUE_APP_STRIPE_LOCALE,
};

Vue.use(StripePlugin, stripeOptions);
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
// Vue.use(IsDemo);
Vue.use(VueMeta, { keyName: 'head' });
Vue.use(VueScrollTo);
Vue.use(Popover);
Vue.use(Vuelidate);
Vue.use(VueMoment);
Vue.use(vueDebounce);
Vue.use(vueCountryRegionSelect);
Vue.use(VueClickOutsideComponent);
Vue.use(browserDetect);

// router & store setup
import router from './router';
import store from './store';
// Installed here (not at the top with the other "critical first" plugins) so the
// interceptor can be given a live reference to the store -- error-handler-module.js
// is itself a Vuex module registered inside store/index.js, so importing the store
// instance directly from that file would be circular.
Vue.use(errorHandler, store);

// global library setup
Vue.prototype.$Chartist = Chartist;

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

Vue.config.errorHandler = (err) => {
  posthog.captureException(err);
};

/* eslint-disable no-new */
const app = new Vue({
  router: router,
  store: store,
  el: '#app',
  render: (h) => h(App),
});

store.$app = app;

// customer.io
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser'

export const cioanalytics = AnalyticsBrowser.load({
  writeKey: '5c8b64b99439d90b5b10'
});

// Vue 2: attach to the prototype (app.config.globalProperties is Vue 3 only
// and threw a TypeError on every page load)
Vue.prototype.$cioanalytics = cioanalytics;
